import { useEffect } from 'react';

/** How many overlays hold the body's scroll right now. */
let holders = 0;
/** The body's own `overflow`, from before the first of them took it. */
let bodyOverflow = '';

/**
 * useBodyScrollLock — holds the document body's scroll while `active`.
 *
 * Every overlay that locks the page shares this one count: the first to lock
 * saves the body's own `overflow` and the last to let go restores it, in
 * whatever order they open and close. Each overlay used to save and restore
 * the value itself, which only holds when they close in the reverse of the
 * order they opened. The report composer hands off to the report reader the
 * other way round, so the reader restored the composer's `hidden` and left
 * the body locked behind it.
 */
export function useBodyScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return undefined;

    if (holders === 0) {
      bodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    holders += 1;

    return () => {
      holders -= 1;
      if (holders === 0) document.body.style.overflow = bodyOverflow;
    };
  }, [active]);
}
